'use client';
import { useState } from 'react';
import moment from 'moment';
import { URI } from '../../../domain/constant';
import { useHistory } from 'react-router-dom';

const EnhancedClientSingleView = ({
  client,
  clientDashboard,
  inputFields,
  onEdit,
  onBack,
  onDashboard,
}) => {
  const history = useHistory();
  const [activeTab, setActiveTab] = useState('overview');

  const formatValue = (value, field) => {
    if (!value) return '-';
    switch (field.inputType) {
      case 'date':
        return moment(value).format('DD MMM YYYY');
      case 'datetime-local':
        return moment(value).utc().format('DD MMM YYYY, hh:mm A');
      case 'checkbox':
        return value ? 'Yes' : 'No';
      default:
        return value;
    }
  };

  const getStatusBadge = (status) => {
    const statusColors = {
      active: 'success',
      inactive: 'secondary',
      pending: 'warning',
      completed: 'success',
      cancelled: 'danger',
    };
    const color = statusColors[status?.toLowerCase()] || 'primary';
    return (
      <span className={`status-badge status-${color}`}>{status || 'N/A'}</span>
    );
  };

  const getPriorityBadge = (priority) => {
    const priorityColors = {
      high: 'danger',
      medium: 'warning',
      low: 'success',
    };
    const color = priorityColors[priority?.toLowerCase()] || 'secondary';
    return (
      <span className={`priority-badge priority-${color}`}>
        <i className={`fa fa-flag priority-icon`}></i>
        {priority || 'Normal'}
      </span>
    );
  };

  return (
    <>
      <style jsx>{`
        .client-view-container {
          // background: linear-gradient(
          //   135deg,
          //   #1e293b 0%,
          //   #334155 25%,
          //   #dc2626 75%,
          //   #b91c1c 100%
          // );
          min-height: 100vh;
          padding: 20px 0;
        }

        .client-header {
          background: white;
          border-radius: 12px;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
          margin-bottom: 20px;
          overflow: hidden;
        }

        .client-header-top {
          background: white;
          color: #1e293b;
          padding: 20px;
          position: relative;
          overflow: hidden;
          border-bottom: 1px solid #e2e8f0;
        }

        .client-header-top::before {
          content: '';
          position: absolute;
          top: -50%;
          left: -50%;
          width: 200%;
          height: 200%;
          background: radial-gradient(
            circle,
            rgba(220, 38, 38, 0.05) 0%,
            transparent 70%
          );
          animation: float 6s ease-in-out infinite;
        }

        @keyframes float {
          0%,
          100% {
            transform: translateY(0px) rotate(0deg);
          }
          50% {
            transform: translateY(-20px) rotate(180deg);
          }
        }

        .client-title-section {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .client-title {
          font-size: 24px;
          font-weight: 700;
          margin: 0;
          display: flex;
          align-items: center;
          gap: 12px;
        }

        .client-icon {
          width: 40px;
          height: 40px;
          background: linear-gradient(
            135deg,
            #1e293b 0%,
            #334155 25%,
            #dc2626 75%,
            #b91c1c 100%
          );
          color: white;
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 18px;
        }

        .client-actions {
          display: flex;
          gap: 8px;
        }

        .action-btn {
          background: linear-gradient(
            135deg,
            #1e293b 0%,
            #334155 25%,
            #dc2626 75%,
            #b91c1c 100%
          );
          border: none;
          color: white;
          padding: 8px 16px;
          border-radius: 6px;
          cursor: pointer;
          font-size: 13px;
          font-weight: 600;
          display: flex;
          align-items: center;
          gap: 6px;
        }

        .action-btn:hover {
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(220, 38, 38, 0.3);
        }

        .action-btn.primary {
          background: #dc2626;
          color: white;
        }

        .action-btn.primary:hover {
          background: #b91c1c;
        }

        .action-btn.dashboard {
          background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
          color: white;
        }

        .action-btn.dashboard:hover {
          background: linear-gradient(135deg, #0056b3 0%, #004085 100%);
        }

        .dashboard-stats {
          padding: 16px 20px;
          background: white;
          border-bottom: 1px solid #f1f5f9;
        }

        .stats-grid {
          display: flex;
          justify-content: center;
          gap: 20px;
          max-width: 600px;
          margin: 0 auto;
        }

        .stat-card {
          background: #f8fafc;
          border: 1px solid #e2e8f0;
          border-radius: 8px;
          padding: 12px 16px;
          text-align: center;
          flex: 1;
          min-width: 120px;
        }

        .stat-value {
          font-size: 20px;
          font-weight: 700;
          color: #1e293b;
          margin-bottom: 4px;
        }

        .stat-label {
          font-size: 11px;
          color: #64748b;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .client-content {
          background: white;
          border-radius: 12px;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
          overflow: hidden;
        }

        .content-tabs {
          display: flex;
          background: #f8fafc;
          border-bottom: 1px solid #e2e8f0;
        }

        .tab-button {
          background: none;
          border: none;
          padding: 12px 20px;
          font-size: 14px;
          font-weight: 600;
          color: #64748b;
          cursor: pointer;
          border-bottom: 3px solid transparent;
          display: flex;
          align-items: center;
          gap: 6px;
        }

        .tab-button.active {
          color: #dc2626;
          border-bottom-color: #dc2626;
          background: white;
        }

        .tab-button:hover:not(.active) {
          color: #1e293b;
          background: rgba(220, 38, 38, 0.05);
        }

        .tab-content {
          padding: 20px;
        }

        .data-list {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
          gap: 16px;
        }

        .data-item {
          display: flex;
          padding: 8px 0;
          border-bottom: 1px solid #f1f5f9;
        }

        .data-item:last-child {
          border-bottom: none;
        }

        .data-label {
          font-size: 13px;
          color: #64748b;
          font-weight: 600;
          min-width: 120px;
          flex-shrink: 0;
        }

        .data-value {
          font-size: 13px;
          color: #1e293b;
          font-weight: 500;
          flex: 1;
          word-wrap: break-word;
          line-height: 1.4;
        }

        .section-divider {
          background: #1e293b;
          color: white;
          padding: 8px 16px;
          margin: 16px -20px;
          font-weight: 600;
          font-size: 13px;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .status-badge {
          padding: 3px 8px;
          border-radius: 4px;
          font-size: 10px;
          font-weight: 700;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .status-success {
          background: #dcfce7;
          color: #166534;
        }

        .status-warning {
          background: #fef3c7;
          color: #92400e;
        }

        .status-danger {
          background: #fee2e2;
          color: #991b1b;
        }

        .status-secondary {
          background: #f1f5f9;
          color: #475569;
        }

        .status-primary {
          background: #dbeafe;
          color: #1d4ed8;
        }

        .priority-badge {
          padding: 3px 8px;
          border-radius: 4px;
          font-size: 10px;
          font-weight: 700;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          display: inline-flex;
          align-items: center;
          gap: 4px;
        }

        .priority-danger {
          background: #fee2e2;
          color: #991b1b;
        }

        .priority-warning {
          background: #fef3c7;
          color: #92400e;
        }

        .priority-success {
          background: #dcfce7;
          color: #166534;
        }

        .priority-secondary {
          background: #f1f5f9;
          color: #475569;
        }

        .priority-icon {
          font-size: 8px;
        }

        .file-link {
          color: #dc2626;
          text-decoration: none;
          font-weight: 600;
          display: inline-flex;
          align-items: center;
          gap: 4px;
          font-size: 12px;
        }

        .file-link:hover {
          color: #b91c1c;
          text-decoration: underline;
        }

        .related-items {
          display: flex;
          flex-wrap: wrap;
          gap: 4px;
        }

        .related-tag {
          background: #f1f5f9;
          color: #475569;
          padding: 2px 6px;
          border-radius: 4px;
          font-size: 11px;
          font-weight: 500;
        }

        .empty-state {
          text-align: center;
          padding: 40px 20px;
          color: #64748b;
        }

        .empty-icon {
          font-size: 48px;
          margin-bottom: 16px;
          opacity: 0.3;
        }

        .long-text {
          max-height: none;
          white-space: pre-wrap;
          word-wrap: break-word;
          line-height: 1.5;
        }

        @media (max-width: 768px) {
          .client-view-container {
            padding: 15px 0;
          }

          .client-title-section {
            flex-direction: column;
            gap: 12px;
            align-items: flex-start;
          }

          .client-actions {
            width: 100%;
            justify-content: flex-start;
          }

          .stats-grid {
            flex-direction: column;
            gap: 12px;
          }

          .data-list {
            grid-template-columns: 1fr;
          }

          .data-item {
            flex-direction: column;
            gap: 4px;
          }

          .data-label {
            min-width: auto;
            font-weight: 700;
          }

          .content-tabs {
            overflow-x: auto;
          }

          .tab-button {
            white-space: nowrap;
            min-width: 100px;
          }
        }
      `}</style>

      <div className='client-view-container'>
        <div className='container-fluid'>
          {/* Client Header */}
          <div className='client-header'>
            <div className='client-header-top'>
              <div className='client-title-section'>
                <h1 className='client-title'>
                  <div className='client-icon'>
                    <i className='fa fa-user-circle'></i>
                  </div>
                  {client?.name || 'Client Details'}
                </h1>
                <div className='client-actions'>
                  <button className='action-btn' onClick={onBack}>
                    <i className='fa fa-arrow-left'></i>
                    Back
                  </button>
                  {onDashboard && (
                    <button
                      className='action-btn dashboard'
                      onClick={onDashboard}
                    >
                      <i className='fa fa-chart-line'></i>
                      Client View
                    </button>
                  )}
                  <button className='action-btn primary' onClick={onEdit}>
                    <i className='fa fa-edit'></i>
                    Edit
                  </button>
                </div>
              </div>
            </div>

            {/* Dashboard Stats */}
            {clientDashboard && (
              <div className='dashboard-stats'>
                <div className='stats-grid'>
                  <div className='stat-card'>
                    <div className='stat-value'>
                      {clientDashboard.total_activities || 0}
                    </div>
                    <div className='stat-label'>Total Activities</div>
                  </div>
                  {/* Always show PENDING and COMPLETED */}
                  {['PENDING', 'COMPLETED'].map((statusKey) => {
                    const found = Array.isArray(clientDashboard.status_counts)
                      ? clientDashboard.status_counts.find(
                          (s) => s.name && s.name.toUpperCase() === statusKey
                        )
                      : null;
                    return (
                      <div className='stat-card' key={statusKey}>
                        <div className='stat-value'>
                          {found ? found.count : 0}
                        </div>
                        <div className='stat-label'>
                          {getStatusBadge(statusKey)}
                        </div>
                      </div>
                    );
                  })}
                  {/* Render any other statuses from API that are not PENDING or COMPLETED */}
                  {Array.isArray(clientDashboard.status_counts) &&
                    clientDashboard.status_counts
                      .filter(
                        (status) =>
                          status.name &&
                          !['PENDING', 'COMPLETED'].includes(
                            status.name.toUpperCase()
                          )
                      )
                      .map((status, idx) => (
                        <div className='stat-card' key={status.name || idx}>
                          <div className='stat-value'>{status.count}</div>
                          <div className='stat-label'>
                            {getStatusBadge(status.name)}
                          </div>
                        </div>
                      ))}
                </div>
              </div>
            )}
          </div>

          {/* Client Content */}
          <div className='client-content'>
            <div className='content-tabs'>
              <button
                className={`tab-button ${
                  activeTab === 'overview' ? 'active' : ''
                }`}
                onClick={() => setActiveTab('overview')}
              >
                <i className='fa fa-info-circle'></i>
                Overview
              </button>
              <button
                className={`tab-button ${
                  activeTab === 'details' ? 'active' : ''
                }`}
                onClick={() => setActiveTab('details')}
              >
                <i className='fa fa-list'></i>
                Details
              </button>
              <button
                className={`tab-button ${
                  activeTab === 'reports' ? 'active' : ''
                }`}
                onClick={() => setActiveTab('reports')}
              >
                <i className='fa fa-chart-bar'></i>
                Reports
              </button>
            </div>

            <div className='tab-content'>
              {activeTab === 'overview' && (
                <div className='data-list'>
                  {Object.keys(inputFields)
                    .slice(0, 12)
                    .map((key) => {
                      const field = inputFields[key];
                      if (field.hideOnView || field.type === 'divider')
                        return null;
                      return (
                        <div key={key} className='data-item'>
                          <span className='data-label'>{field.title}:</span>
                          <span className='data-value'>
                            {key === 'status' ? (
                              getStatusBadge(client?.[key])
                            ) : key === 'priority' ? (
                              getPriorityBadge(client?.[key])
                            ) : field.type === 'file' && client?.[key] ? (
                              <a
                                href={`/uploads/${client[key]}`}
                                target='_blank'
                                className='file-link'
                                rel='noreferrer'
                              >
                                <i className='fa fa-external-link-alt'></i>
                                View File
                              </a>
                            ) : field.type === 'related' && field.multiple ? (
                              <div className='related-items'>
                                {client?.[key]?.map((item, index) => (
                                  <span key={index} className='related-tag'>
                                    {field.static ? item : item[field.field]}
                                  </span>
                                ))}
                              </div>
                            ) : (
                              formatValue(client?.[key], field)
                            )}
                          </span>
                        </div>
                      );
                    })}
                </div>
              )}

              {activeTab === 'details' && (
                <div>
                  {Object.keys(inputFields).map((key) => {
                    const field = inputFields[key];
                    if (field.type === 'divider') {
                      return (
                        <div key={key} className='section-divider'>
                          {field.title}
                        </div>
                      );
                    }
                    if (field.hideOnView) return null;

                    const value = client?.[key];
                    let displayValue;

                    if (field.type === 'html' && value) {
                      displayValue = (
                        <div
                          dangerouslySetInnerHTML={{
                            __html: value,
                          }}
                        />
                      );
                    } else if (field.type === 'gallery' && value) {
                      displayValue = (
                        <div className='related-items'>
                          {value.map((pic, index) => (
                            <a
                              key={index}
                              href={`/uploads/${pic.image}`}
                              target='_blank'
                              className='file-link'
                              rel='noreferrer'
                            >
                              <i className='fa fa-image'></i>
                              Image {index + 1}
                            </a>
                          ))}
                        </div>
                      );
                    } else if (field.type === 'file' && value) {
                      displayValue = (
                        <a
                          href={`${URI}${value}`}
                          target='_blank'
                          className='file-link'
                          rel='noreferrer'
                        >
                          <i className='fa fa-external-link-alt'></i>
                          View File
                        </a>
                      );
                    } else if (typeof value === 'object' && value !== null) {
                      displayValue =
                        value.name || value.title || JSON.stringify(value);
                    } else {
                      displayValue = formatValue(value, field);
                    }

                    return (
                      <div key={key} className='data-item'>
                        <span className='data-label'>{field.title}:</span>
                        <span className='data-value'>
                          <div className='long-text'>{displayValue}</div>
                        </span>
                      </div>
                    );
                  })}

                  {/* System Information */}
                  <div className='section-divider'>System Information</div>
                  {client?.created_by && (
                    <div className='data-item'>
                      <span className='data-label'>Created By:</span>
                      <span className='data-value'>
                        {client.created_by.name}
                      </span>
                    </div>
                  )}
                  {client?.updated_by && (
                    <div className='data-item'>
                      <span className='data-label'>Updated By:</span>
                      <span className='data-value'>
                        {client.updated_by.name}
                      </span>
                    </div>
                  )}
                  {client?.createdAt && (
                    <div className='data-item'>
                      <span className='data-label'>Created At:</span>
                      <span className='data-value'>
                        {moment(client.createdAt).format(
                          'DD MMM YYYY, hh:mm A'
                        )}
                      </span>
                    </div>
                  )}
                  {client?.updatedAt && (
                    <div className='data-item'>
                      <span className='data-label'>Updated At:</span>
                      <span className='data-value'>
                        {moment(client.updatedAt).format(
                          'DD MMM YYYY, hh:mm A'
                        )}
                      </span>
                    </div>
                  )}
                </div>
              )}

              {activeTab === 'reports' && (
                <div className='empty-state'>
                  <i className='fa fa-chart-bar empty-icon'></i>
                  <h3>Reports Coming Soon</h3>
                  <p>Detailed reports and analytics will be available here.</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EnhancedClientSingleView;
